import { initialState, mapCommentsLikes } from "./selectors";
import {
  ADD_TOUCHPOINT_REQUEST,
  ADD_TOUCHPOINT_SUCCESS,
  UPDATE_TOUCHPOINT_REQUEST,
  UPDATE_TOUCHPOINT_SUCCESS,
  GET_TOUCHPOINTS_REQUEST,
  GET_TOUCHPOINTS_SUCCESS,
  GET_AUDIT_TOUCHPOINTS_REQUEST,
  GET_AUDIT_TOUCHPOINTS_SUCCESS,
  GET_TOUCHPOINT_REQUEST,
  GET_TOUCHPOINT_SUCCESS,
  LIKE_TOUCHPOINT_REQUEST,
  LIKE_TOUCHPOINT_SUCCESS,
  FAVOR_TOUCHPOINT_SUCCESS,
  DELETE_TOUCHPOINT_REQUEST,
  DELETE_TOUCHPOINT_SUCCESS,
  ADD_TOUCHPOINT_COMMENT_SUCCESS,
  DELETE_TOUCHPOINT_COMMENT_SUCCESS,
  LIKE_TOUCHPOINT_COMMENT_SUCCESS,
  EDIT_TOUCHPOINT_COMMENT_SUCCESS,
} from "./actions";

export default function touchPoint(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ADD_TOUCHPOINT_REQUEST:
      return {
        ...state,
      };
    case ADD_TOUCHPOINT_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_TOUCHPOINT_REQUEST:
      return {
        ...state,
      };
    case UPDATE_TOUCHPOINT_SUCCESS:
      return {
        ...state,
      };
    case GET_TOUCHPOINTS_REQUEST:
      return {
        ...state,
        touchPoints: [],
      };
    case GET_TOUCHPOINTS_SUCCESS:
      return {
        ...state,
        touchPoints: payload,
      };
    case GET_AUDIT_TOUCHPOINTS_REQUEST:
      return {
        ...state,
        auditTouchPoints: null,
      };
    case GET_AUDIT_TOUCHPOINTS_SUCCESS:
      return {
        ...state,
        auditTouchPoints: payload,
      };
    case GET_TOUCHPOINT_REQUEST:
      return {
        ...state,
      };
    case GET_TOUCHPOINT_SUCCESS:
      const mappedComments = mapCommentsLikes(payload);
      return {
        ...state,
        touchPoint: { ...payload, comments: mappedComments },
      };
    case LIKE_TOUCHPOINT_REQUEST:
      return {
        ...state,
      };
    case LIKE_TOUCHPOINT_SUCCESS:
      return {
        ...state,
        touchPoint: {
          ...state.touchPoint,
          liked: payload.wasLiked,
          touchPoint: {
            ...state.touchPoint.touchPoint,
            likes: payload.likes,
          },
        },
      };
    case FAVOR_TOUCHPOINT_SUCCESS:
      return {
        ...state,
        touchPoint: {
          ...state.touchPoint,
          touchPoint: {
            ...state.touchPoint.touchPoint,
            favored: payload.wasLiked,
          },
        },
      };
    case DELETE_TOUCHPOINT_REQUEST:
      return {
        ...state,
        touchPoint: null,
      };
    case DELETE_TOUCHPOINT_SUCCESS:
      return {
        ...state,
        touchPoint: null,
      };
    case ADD_TOUCHPOINT_COMMENT_SUCCESS:
      const currentCommentsIDs = new Set(state.touchPoint.comments.map(({ _id }) => _id));
      const newComments = [...state.touchPoint.comments, ...payload.filter(({ _id }) => !currentCommentsIDs.has(_id))];
      const touchPoint = {
        ...state.touchPoint,
        comments: newComments,
      };
      return {
        ...state,
        touchPoint,
      };
    case EDIT_TOUCHPOINT_COMMENT_SUCCESS:
      const touchPointEdited = {
        ...state.touchPoint,
        comments: payload,
      };
      return {
        ...state,
        touchPoint: touchPointEdited,
      };
    case DELETE_TOUCHPOINT_COMMENT_SUCCESS:
      const newCommentsIDs = new Set(payload.map(({ _id }) => _id));
      const filteredComments = state.touchPoint.comments.filter(({ _id }) => newCommentsIDs.has(_id));
      const tp = {
        ...state.touchPoint,
        comments: filteredComments,
      };
      return {
        ...state,
        touchPoint: tp,
      };
    case LIKE_TOUCHPOINT_COMMENT_SUCCESS: {
      const mappedComments = mapCommentsLikes({
        comments: state.touchPoint.comments,
        commentLikes: payload.commentLikes,
      });
      return {
        ...state,
        touchPoint: { ...state.touchPoint, comments: mappedComments },
      };
    }
    default:
      return state;
  }
}
